import React from 'react'

import {
  Backdrop,
  CircularProgress,
  makeStyles,
  InputBase,
  TextareaAutosize
} from '@material-ui/core'
import { Add, CloseRounded } from '@material-ui/icons'
import StyledSVG from './StyledSVG'

import videoSVG from '../../assets/icons/video.svg'
import headsetSVG from '../../assets/icons/headset.svg'
import docSVG from '../../assets/icons/doc.svg'
import mensageiroSendSVG from '../../assets/icons/mensageiro-send.svg'

const useStyles = makeStyles(theme => ({
  root: {
    height: '89%',
    backgroundColor: '#ADB8CC57',
    position: 'relative'
  },
  current_file_name: {
    width: '100%',
    textAlign: 'center',
    color: 'unset',
    textDecoration: 'none'
  },
  header: {
    padding: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '10%'
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '70%',
    position: 'relative',
    '& .MuiInputBase-root': {
      margin: '3px',
      backgroundColor: '#FFFFFF',
      minHeight: '50px',
      width: '60%',
      borderRadius: 30,
      padding: 10,
      overflowX: 'hidden',
      overflowY: 'auto',
      position: 'absolute',
      bottom: 2
    }
  },
  images_responsive: {
    objectFit: 'cover',
    maxWidth: '400px',
    maxHeight: '400px',
    [theme.breakpoints.down('750')]: {
      maxWidth: '300px',
      maxHeight: '300px'
    },
    [theme.breakpoints.down('500')]: {
      maxWidth: '250px',
      maxHeight: '250px'
    },
    [theme.breakpoints.down('450')]: {
      maxWidth: '200px',
      maxHeight: '200px'
    },
    [theme.breakpoints.down('380')]: {
      maxWidth: '150px',
      maxHeight: '150px'
    }
  },
  selected_file_item: {
    border: '2px solid #386093',
    borderRadius: 8
  },
  add_file: {
    width: 50,
    height: 50,
    borderRadius: 8,
    border: '1px dashed #386093',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  file_item: {
    objectFit: 'cover',
    width: 50,
    height: 50,
    borderRadius: 8
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: 32,
    gap: 8
  },
  pointer: {
    cursor: 'pointer'
  },
  previews_wrapper: {
    position: 'relative'
  },
  remove_item_button: {
    width: 20,
    height: 20,
    position: 'absolute',
    top: 5,
    right: 5,
    transition: 'opacity 0.3s ease-in-out'
  },
  send_message: {
    borderRadius: 50,
    width: 75,
    height: 75,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 15,
    right: 15,
    backgroundColor: '#386093'
  },
  files_responsive: {
    backgroundColor: '#FFFF',
    minWidth: 300,
    minHeight: 200,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around'
  },
  images_wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 50,
    height: 50
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}))
const MessagesFilesComponent = props => {
  const {
    files,
    inputValue,
    setInputValue,
    setFiles,
    handleAddFiles,
    handleCreateMessage
  } = props
  const inputRef = React.useRef(null)
  const [backdrop, setBackdrop] = React.useState(false)
  const classes = useStyles()
  const [currentFile, setCurrentFile] = React.useState(files[0])
  const [cursorOnItem, setCursorOnItem] = React.useState({
    item: null
  })

  const handleChangeFile = item => {
    setCurrentFile(prev => {
      return item
    })
  }

  const handleDispatchCreateMessage = async () => {
    setBackdrop(true)
    await handleCreateMessage()
    setFiles([])
  }

  React.useEffect(() => {
    return () => {
      URL.revokeObjectURL(currentFile.preview)
      files.forEach(file => {
        URL.revokeObjectURL(file.preview)
      })
    }
  }, [])

  const handleRemoveFile = filename => {
    setFiles(prev => {
      const fileToRemove = prev.find(item => item.name === filename)

      if (fileToRemove?.preview) {
        URL.revokeObjectURL(fileToRemove.preview)
      }

      const newData = prev.filter(item => item.name !== filename)

      if (!newData.find(item => item.name === currentFile?.name)) {
        setCurrentFile(newData[0])
      }

      return newData
    })
  }

  const handleImagesPreview = file => {
    if (file.setted_type === 'image') {
      return (
        <div
          className={`${classes.images_wrapper} ${classes.pointer}
              ${
                file.name === currentFile.name ? classes.selected_file_item : ''
              }`}
        >
          <img
            src={file.preview}
            onClick={() => handleChangeFile(file)}
            className={classes.file_item}
          />
        </div>
      )
    } else if (file.setted_type.includes('video')) {
      return (
        <div
          onClick={() => handleChangeFile(file)}
          className={`${classes.pointer} ${classes.images_wrapper}
         ${file.name === currentFile.name ? classes.selected_file_item : ''}`}
        >
          <StyledSVG src={videoSVG} width={30} height={30} />
        </div>
      )
    } else if (file.setted_type.includes('audio')) {
      return (
        <div
          onClick={() => handleChangeFile(file)}
          className={`${classes.pointer} ${classes.images_wrapper}
          ${file.name === currentFile.name ? classes.selected_file_item : ''}`}
        >
          <StyledSVG src={headsetSVG} width={30} height={30} />
        </div>
      )
    } else {
      return (
        <div
          onClick={() => handleChangeFile(file)}
          className={`${classes.pointer} ${classes.images_wrapper}
         ${file.name === currentFile.name ? classes.selected_file_item : ''}`}
        >
          <StyledSVG src={docSVG} width={30} height={30} />
        </div>
      )
    }
  }

  const handleCurrentFilePreview = () => {
    if (currentFile?.setted_type.includes('image')) {
      return (
        <img className={classes.images_responsive} src={currentFile.preview} />
      )
    } else if (currentFile?.setted_type.includes('video')) {
      return (
        <video key={currentFile.name} width='400' height='400' controls>
          <source src={currentFile.preview} type={currentFile.type} />
          O seu navegador não suporta o elemento de <code>video</code>.
        </video>
      )
    } else if (currentFile?.setted_type.includes('audio')) {
      return (
        <audio controls>
          <source src={currentFile.preview} type={currentFile.type} />
          O seu navegador não suporta o elemento de <code>audio</code>.
        </audio>
      )
    } else {
      return (
        <div className={classes.files_responsive}>
          <StyledSVG src={docSVG} width={100} height={100} />
          <span>Previa indisponível</span>
          <span>{currentFile.setted_type}</span>
        </div>
      )
    }
  }

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <CloseRounded
          className={classes.pointer}
          onClick={() => setFiles([])}
        />
        {currentFile.setted_type !== 'images' && (
          <a
            href={URL.createObjectURL(currentFile)}
            target='_blank'
            className={classes.current_file_name}
            rel='noreferrer'
          >
            {currentFile.name}
          </a>
        )}
      </header>
      <main className={classes.main}>
        {handleCurrentFilePreview()}
        <InputBase
          fullWidth
          disableUnderline
          value={inputValue}
          onChange={event => setInputValue(event.target.value)}
          placeholder='Escreva uma legenda'
          onKeyDown={event => {
            if (event.key === 'Enter') {
              handleDispatchCreateMessage()
            }
          }}
          inputComponent={TextareaAutosize}
          inputProps={{
            minRows: 1,
            maxRows: 6,
            style: {
              resize: 'none',
              marginLeft: 15
            }
          }}
        />
      </main>
      <footer className={classes.footer}>
        {files.map((item, index) => {
          return (
            <div
              key={index}
              onMouseEnter={() => setCursorOnItem({ item: item.name })}
              onMouseLeave={() => setCursorOnItem({ item: null })}
              className={classes.previews_wrapper}
            >
              {handleImagesPreview(item)}
              <CloseRounded
                onClick={() => handleRemoveFile(item.name)}
                style={
                  item.name !== cursorOnItem.item
                    ? { opacity: 0 }
                    : { opacity: 1 }
                }
                className={`${classes.remove_item_button} ${classes.pointer}`}
              />
            </div>
          )
        })}
        <div
          onClick={() => inputRef.current && inputRef.current.click()}
          className={`${classes.add_file} ${classes.pointer}`}
        >
          <Add />
          <input
            hidden
            multiple
            name='image_files'
            onChange={handleAddFiles}
            ref={inputRef}
            type='file'
          />
        </div>
      </footer>
      <div
        onClick={handleDispatchCreateMessage}
        className={`${classes.send_message} ${classes.pointer}`}
      >
        <StyledSVG src={mensageiroSendSVG} />
      </div>
      <Backdrop className={classes.backdrop} open={backdrop}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </div>
  )
}

export default MessagesFilesComponent
